export interface BRANCH {
  Id: number;
  Name: string;
  IsMainBranch: boolean;
  CityName: string;
}

export interface USER {
  Id?: number;
  UserName?: string;
}
